import { supabase } from "@/services/supabase/client";

export async function setUserSession(hashParams: URLSearchParams) {
  const accessToken = hashParams.get("#access_token");
  const refreshToken = hashParams.get("refresh_token");
  const expiresIn = hashParams.get("expires_in");
  const tokenType = hashParams.get("token_type");

  if (accessToken && refreshToken && expiresIn && tokenType) {
    const { data } = await supabase.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken,
    });

    return data;
  }
}

export async function saveAppleFullName(
  profile: {
    user?: string;
    email?: string | null;
    givenName?: string | null;
    familyName?: string | null;
    name?: { firstName?: string; lastName?: string } | null;
  },
  userId?: string
) {
  // Apple only provides the user's full name on the first sign-in
  // Save it to user metadata and profiles table for future reference
  const givenName = profile.givenName || (typeof profile.name === "object" ? profile.name?.firstName : undefined);
  const familyName = profile.familyName || (typeof profile.name === "object" ? profile.name?.lastName : undefined);

  if (givenName || familyName) {
    const nameParts = [];
    if (givenName) nameParts.push(givenName);
    if (familyName) nameParts.push(familyName);
    const fullName = nameParts.join(" ").trim();

    if (fullName) {
      try {
        await supabase.auth.updateUser({
          data: {
            full_name: fullName,
            given_name: givenName,
            family_name: familyName,
          },
        });

        if (userId) {
          await supabase.from("profiles").upsert({
            id: userId,
            name: fullName,
          });
        }
      } catch (error) {
        console.error("Failed to save Apple full name:", error);
      }
    }
  }
}
